import Header from '../../components/admin/header/Header';
import SearchKeyword from '../../components/admin/common/SearchKeyword';
import Content from '../../components/admin/service/Content';
import React, { useState, useEffect } from 'react';

export default function Contact() {
  const [searchParams, setSearchParams] = useState({});

  const handleSearch = (searchData) => {
    console.log('고객센터문의 검색:', searchData);
    setSearchParams(searchData);
  };

  return (
    <>
      <Header></Header>
      <div className="content-wrapper">
        <div className="titleNav">고객센터(문의)</div>

        <div className="">
          <SearchKeyword
            placeholder="검색"
            searchType="name"
            onSearch={handleSearch}
          />
          <Content />
        </div>
      </div>
    </>
  );
}
